// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Medal20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Medal20: FC<Medal20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M10 11a2.411 2.411 0 0 1-1.77-.73A2.41 2.41 0 0 1 7.5 8.5c0-.694.243-1.285.73-1.77A2.41 2.41 0 0 1 10 6a2.41 2.41 0 0 1 1.77.73c.487.485.73 1.076.73 1.77a2.41 2.41 0 0 1-.73 1.77A2.411 2.411 0 0 1 10 11Zm-4.52 8v-5.833c-.598-.514-1.077-1.202-1.438-2.063A6.683 6.683 0 0 1 3.5 8.5c0-1.806.632-3.34 1.896-4.604C6.66 2.632 8.194 2 10 2s3.34.632 4.604 1.896C15.868 5.16 16.5 6.694 16.5 8.5c0 .889-.167 1.76-.5 2.615-.333.854-.833 1.544-1.5 2.071V19L10 18l-4.52 1ZM10 13.5c1.389 0 2.57-.486 3.542-1.458C14.514 11.069 15 9.889 15 8.5c0-1.389-.486-2.57-1.458-3.542C12.569 3.986 11.389 3.5 10 3.5c-1.389 0-2.57.486-3.542 1.458C5.486 5.931 5 7.111 5 8.5c0 1.389.486 2.57 1.458 3.542.973.972 2.153 1.458 3.542 1.458Zm-3.02 3.625 3.02-.667 3 .667V14.25c-.458.25-.941.438-1.448.563A6.46 6.46 0 0 1 10 15a6.954 6.954 0 0 1-1.563-.177c-.513-.118-1-.31-1.458-.573v2.875Z" />
        </svg>
    );
};

export default Medal20;
